import { Alert } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { RecordingFetchRetryButton } from './RecordingFetchRetryButton';

type Props = {
  /** Повторный запрос записи у источника; без него сообщение показывается без значка повтора */
  onRetry?: () => void;
  className?: string;
  alertClassName?: string;
};

/**
 * «Аудиофайл недоступен» в области записи диалога, при неудаче получения у источника — со значком
 * повторного запроса внутри самого сообщения.
 *
 * Значок идёт в строке текста, а не рядом с сообщением: так он не отнимает у текста ширину,
 * и в тесной области строка просто переносится по словам.
 */
export const RecordingUnavailableNotice: FC<Props> = ({ onRetry, className, alertClassName }) => {
  const { t } = useTranslation('dialogs');

  return (
    <div className={cn('w-full min-w-0', className)}>
      <Alert
        className={cn('text-muted-foreground', alertClassName)}
        title={
          <>
            {t('audioUnavailable')}
            {onRetry && <RecordingFetchRetryButton onConfirm={onRetry} />}
          </>
        }
      />
    </div>
  );
};
